import React from 'react';
interface WaveDividerProps {
  className?: string;
  position?: 'top' | 'bottom';
  fill?: string;
}
export function WaveDivider({
  className = '',
  position = 'bottom',
  fill = 'currentColor'
}: WaveDividerProps) {
  const transform = position === 'top' ? 'rotate(180deg)' : '';
  return <div className={`w-full overflow-hidden leading-none ${className}`} style={{
    transform
  }} data-id="element-257">
      <svg className="relative block w-full h-[40px] md:h-[80px] lg:h-[120px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-258">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill={fill} data-id="element-259"></path>
      </svg>
    </div>;
}